// GameUI.js
var GameUi = pc.createScript('gameUi');

GameUi.attributes.add('homeButton', {type: 'entity'});
GameUi.attributes.add('jokerButton', {type: 'entity'});
GameUi.attributes.add('shakeButton', {type: 'entity'});
GameUi.attributes.add('levelLabel', {type: 'entity'});
GameUi.attributes.add('gameVersion', {type: 'entity'});

GameUi.prototype.initialize = function () {
    GameUi.instance = this;
    
    this.app.on('gameManager:gamePlayMode', this.Status, this);
    this.app.on('gameManager:updatestatus', this.gameUpdateStatus, this);

    this.entity.on("destroy", function () {
        this.app.off('gameManager:gamePlayMode', this.Status, this);
    }, this);

};

GameUi.prototype.showHideHomeButton = function(status) {
    this.homeButton.enabled = status;
};

GameUi.prototype.showHideJokerButton = function(status) {
    this.jokerButton.enabled = status;
};

GameUi.prototype.showHideShakeButton = function(status) {
    this.shakeButton.enabled = status;
};

GameUi.prototype.showLevelName = function(levelName){
    this.levelLabel.element.text = levelName;
};

GameUi.prototype.Status = function(playMode){

    if (playMode == gamePlayMode.Normal) {
        this.levelLabel.element.text = PlayerManager.instance.levelData.levelName;
    }
    else if(playMode == gamePlayMode.Places) {
        this.levelLabel.element.text = GameManager.instance.placeData.levelName;
    }
    else if (playMode == gamePlayMode.MiniGame) {
        this.levelLabel.element.text = GameManager.instance.eventData.eventName;
    }
};

GameUi.prototype.gameUpdateStatus = function(stat) {

    if(stat === gamestatus.Lose || stat === gamestatus.Quit || stat === gamestatus.Win) {
        this.showHideShakeButton(false);
    }
    else if (stat === gamestatus.Play || stat === gamestatus.OfferPlay || stat === gamestatus.Resume) {
        if (PlayerManager.instance.userData.newPlayer == true){
            this.showHideShakeButton(false);
        }
        else {
            this.showHideShakeButton(true);
        }
    }  
};

